import React from 'react'

export const HeaderBackgroundDesktop = () => (
  <div className='flex w-full h-[158px]'>
    <div className='flex flex-shrink-0'>
      <svg
        width='500'
        height='158'
        viewBox='0 0 500 158'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0 0H1920V158H269.786C259.049 158 248.763 153.683 241.241 146.021L199.5 103.5C169.477 74.7597 120.561 81.2086 99.0125 116.748L80.578 147.151C76.4942 153.886 69.1894 158 61.3127 158H0V0Z'
          fill='#CCE0DD'
        />
      </svg>
    </div>
    <div className='bg-[#CCE0DD] flex flex-grow ' />
  </div>
)

export const HeaderBackgroundMobile = () => (
  <div className='flex w-full h-[68px]'>
    <div className='flex flex-shrink-0'>
      <svg
        width='375'
        height='68'
        viewBox='0 0 375 68'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0 0H375V68H133.797C124.249 68 115.015 64.5843 107.765 58.3703L87.5 41C69.1784 26.5068 42.496 30.0629 28.6097 48.8487L18.6151 62.3696C15.9975 65.9108 11.8551 68 7.45147 68H0V0Z'
          fill='#CCE0DD'
        />
      </svg>
    </div>
    <div className='bg-[#CCE0DD] flex flex-grow' />
  </div>
)
